var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"information-page"}},[_c('div',[_c('header-bar')],1),_c('div',{staticClass:"main_area",staticStyle:{"margin-top":"76px"}}),_c('div',{staticClass:"content_area"},[_c('info-content',{attrs:{"filename":_vm.$route.params.pn}})],1),_c('div',{staticClass:"footerArea"},[_c('site-map'),_c('copy-right')],1),_c('gotop-button')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }